import React from 'react';
import { BrowserRouter, HashRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { AgentProvider } from './contexts/AgentContext';
import { WalletProvider } from './providers/WalletProvider';
import { ToastContainer } from './components/toast/ToastContainer';
import { ErrorBoundary } from './components/ErrorBoundary';
import { MaintenanceDialog } from './components/MaintenanceDialog';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LandingPage } from './pages/LandingPage';
import { ChatPage } from './pages/ChatPage';
import { ProfilePage } from './pages/ProfilePage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { useToast } from './contexts/ToastContext';
import { setToastEmitter } from './utils/toast';

const ToastManager = () => {
  const { toasts, hideToast, showToast } = useToast();

  React.useEffect(() => {
    setToastEmitter(showToast);
    return () => setToastEmitter(null);
  }, [showToast]);

  return <ToastContainer toasts={toasts} onClose={hideToast} />;
};

const AppRoutes = () => {
  return (
    <WalletProvider>
      <AuthProvider>
        <ToastProvider>
          <AgentProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route
              path="/convo/shared/:id"
              element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/convo/*"
              element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
          </Routes>
            <ToastManager />
            <MaintenanceDialog />
          </AgentProvider>
        </ToastProvider>
      </AuthProvider>
    </WalletProvider>
  );
};

const App = () => {
  const isExtension = import.meta.env.VITE_EXTENSION_BUILD === 'true' || window.location.protocol === 'chrome-extension:';
  const RouterComponent = isExtension ? HashRouter : BrowserRouter;

  return (
    <ErrorBoundary>
      <RouterComponent>
        <AppRoutes />
      </RouterComponent>
    </ErrorBoundary>
  );
};

export default App;
